import styled, { keyframes } from 'styled-components';
import { Menu, MenuButton, MenuItem } from '@szhsin/react-menu';

export const ChatSectionStyled = styled.div`
  width: 100%;
  height: 100%;
  min-height: 0;
  flex: 1;
  display: flex;
  overflow: hidden;
  position: relative;

  /* &.sources-active {
    @media (min-width: 992px) {
      padding: 0 290px 0 0;
    }
    @media (min-width: 1400px) {
      padding: 0 390px 0 0;
    }
    @media (min-width: 1600px) {
      padding: 0 490px 0 0;
    }
  } */
`;

const pulse = keyframes`
  0% { opacity: 0.5; }
  50% { opacity: 1; }
  100% { opacity: 0.5; }
`;

export const ChatColumn = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
  min-height: 0;
  min-width: 0;
  overflow: hidden;

  &.poly-chat-layout {
    height: 100%;
  }

  .poly-chat-messages {
    flex: 1;
    min-height: 0;
    min-width: 0;
    height: auto !important;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 16px 12px;

    @media (min-width: 768px) {
      padding: 20px 24px;
    }
  }

  .poly-chat-empty {
    flex: 1;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media (min-width: 768px) {
      min-height: 240px;
    }
  }

  .poly-chat-thread {
    max-width: 48rem;
    margin: 0 auto;
    width: 100%;
    min-width: 0;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .poly-chat-input {
    flex-shrink: 0;
    padding: 12px 12px 16px;
    border-top: 1px solid var(--line);
    background: var(--body-bg);

    @media (min-width: 768px) {
      padding: 16px 24px 20px;
    }

    .poly-chat-search {
      max-width: 48rem;
      margin: 0 auto;
    }
  }

  .error-text {
    color: var(--danger);
  }

  .chat-loader-text {
    display: block;
    font-weight: 500;
    margin-bottom: 10px;
    color: var(--quiet);
    animation: ${pulse} 1.5s ease-in-out infinite;
  }

  .text-block {
    flex-grow: 1;
    min-height: 0;
    overflow: auto;

    .user-text {
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      justify-content: flex-end;
      gap: 10px;
      position: relative;
      padding: 0;
      margin-bottom: 16px;

      .icon-box {
        display: none;
      }

      .title {
        max-width: min(80%, 36rem);
        margin: 0;
        padding: 12px 16px;
        border-radius: 18px 18px 4px 18px;
        background: var(--o1);
        color: var(--ink);
        font-weight: 500;
        font-size: 14px;
        line-height: 1.5;
        white-space: pre-line;
        box-shadow: var(--shadow);
      }

      .see-source-button {
        position: static;
        flex-shrink: 0;
        margin: 0;
        padding: 5px 10px;
        color: var(--ink);
        background: var(--card);
        border: 1px solid var(--line);
        border-radius: 9999px;
        font-size: 12px;
        line-height: 1.2;
        cursor: pointer;
        white-space: nowrap;

        &:hover {
          border-color: var(--o1);
          color: var(--o2);
        }
      }
    }

    .heading {
      margin: 0 0 16px;
      position: relative;
      padding-left: 0;
      line-height: 1.5;
      max-width: 100%;
      min-width: 0;
      overflow-x: hidden;

      &:not(.user-text) {
        display: grid;
        grid-template-columns: 36px minmax(0, 1fr);
        align-items: start;
        column-gap: 12px;
        row-gap: 8px;

        .icon-box {
          position: static;
          display: flex;
          grid-row: 1;
          margin-top: 2px;
        }

        .swiper-holder,
        .ai-message-content,
        .chat-loader-text,
        .error-text {
          grid-column: 2;
        }

        .ai-message-content {
          max-width: min(100%, 42rem);
          width: fit-content;
          min-width: 0;
          box-sizing: border-box;
          padding: 14px 16px;
          border-radius: 4px 18px 18px 18px;
          background: var(--card);
          border: 1px solid var(--line);
          color: var(--ink);
          box-shadow: var(--shadow);
          font-size: 15px;
          line-height: 1.55;
          overflow-x: hidden;
          overflow-wrap: anywhere;
          word-break: break-word;

          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          p,
          li,
          span,
          strong,
          b {
            color: var(--ink);
          }

          p {
            margin: 0 0 0.75em;

            &:last-child {
              margin-bottom: 0;
            }
          }

          em {
            color: var(--quiet);
          }

          a {
            color: var(--o2);
          }

          blockquote {
            color: var(--quiet);
            border-left: 2px solid var(--o1);
            background: var(--o-tint);
            margin: 0.75em 0;
            padding: 8px 12px;
            border-radius: 0 8px 8px 0;
          }

          code {
            color: var(--o-deep);
            background: var(--band);
            padding: 1px 6px;
            border-radius: 4px;
            font-size: 0.92em;
          }

          pre code {
            color: var(--ink);
            background: transparent;
            padding: 0;
          }

          hr {
            border-color: var(--line);
          }
        }
      }

      a {
        text-decoration: underline;
        color: var(--o2);
      }

      .icon-box {
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 36px;
        height: 36px;
        font-size: 14px;
        line-height: 1;
        font-weight: 700;
        text-transform: uppercase;
        border-radius: 50%;
        color: var(--ink);
        background: var(--card);
        border: 1px solid var(--line);
        box-shadow: var(--shadow);
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        &--purple {
          background: var(--o-tint);
          color: var(--o2);
          border-color: var(--line);
        }
      }

      .ai-message-content {
        width: fit-content;
        max-width: min(100%, 42rem);
        min-width: 0;
        box-sizing: border-box;
        overflow-x: hidden;
      }

      table {
        border-collapse: collapse;
        width: 100%;
      }

      th,
      td {
        border: 1px solid var(--line);
        border-spacing: 0;
        padding: 10px 12px;
        text-align: left;
        vertical-align: top;
        overflow-wrap: anywhere;
        word-break: break-word;
        color: var(--ink);
      }

      th {
        font-weight: 700;
        background: var(--band);
      }

      .lucide-download {
        display: none;
      }

      .title {
        display: block;
        margin: 0;
      }

      pre {
        background-color: var(--ink-2);
        color: var(--on-ink);
        padding: 16px;
        border-radius: 12px;
        font-family: 'Fira Code', 'Source Code Pro', monospace;
        font-size: 14px;
        line-height: 22px;
        margin-top: 10px;
        margin-bottom: 10px;
        border: 1px solid var(--ink-line);
        overflow-x: auto;

        &::-webkit-scrollbar {
          height: 5px;
        }
        &::-webkit-scrollbar-thumb {
          background: #555;
          border-radius: 4px;
        }
        &::-webkit-scrollbar-thumb:hover {
          background: #777;
        }
      }
    }
  }

  .swiper-holder {
    position: relative;

    .swiper {
      padding-top: 20px;
      margin-bottom: 20px;
      overflow: hidden;
      /* .swiper-wrapper {
      display: flex;
      gap: 12px;
      overflow: hidden;
    } */
      .swiper-slide {
        /* cursor: pointer;
      margin: 0 !important; */

        .img-wrap {
          display: block;
          width: 200px !important;
          height: 150px;
          overflow: hidden;
          border-radius: 10px;
          border: 1px solid #cdcdcd;

          @media (min-width: 768px) {
            width: 300px !important;
            height: 200px;
          }

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }

    .swiper-controls {
      display: flex;
      gap: 10px;
    }

    .swiper-controls button {
      position: absolute;
      top: 50%;
      right: 10px;
      left: auto;
      width: 30px;
      height: 30px;
      background: #f1f1f9;
      color: var(--black);
      border-radius: 50%;
      border: none;
      cursor: pointer;

      &::after {
        display: none;
      }
      svg {
        width: 20px;
      }
    }

    .swiper-button-prev {
      right: auto !important;
      left: 10px !important;
    }
  }
`;

export const KnowHowChatInputStyled = styled.div`
  position: relative;
  display: flex;
  align-items: flex-end;
  gap: 8px;
  width: 100%;
  max-width: 48rem;
  margin: 0 auto;
  padding: 0 4px;

  @media (min-width: 768px) {
    padding: 0;
  }

  .session-hint {
    pointer-events: none;
    position: absolute;
    top: -40px;
    left: 50%;
    z-index: 10;
    transform: translateX(-50%);
    white-space: nowrap;
    border-radius: 9999px;
    border: 1px solid var(--line);
    background: var(--card);
    padding: 6px 12px;
    font-size: 11px;
    color: var(--ink);
    box-shadow: var(--shadow);

    @media (min-width: 480px) {
      font-size: 12px;
    }

    span {
      color: var(--o2);
      font-weight: 600;
    }
  }

  textarea {
    flex: 1;
    min-height: 44px;
    max-height: 128px;
    resize: none;
    outline: none;
    border-radius: 22px;
    border: 1px solid var(--line);
    background: var(--card);
    color: var(--ink);
    padding: 12px 16px;
    font-size: 14px;
    line-height: 1.4;
    font-family: inherit;
    box-shadow: var(--shadow);

    &::placeholder {
      color: var(--quiet);
    }

    &.ready:focus {
      border-color: var(--o1);
      box-shadow: 0 0 0 3px var(--o-halo);
    }

    &.locked {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  button {
    width: 44px;
    height: 44px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: none;
    background: var(--primary-gradient);
    color: var(--primary-foreground);
    cursor: pointer;
    transition:
      transform 0.15s ease,
      opacity 0.15s ease;

    &:hover:not(:disabled) {
      transform: translateY(-1px);
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }
`;

export const SearchResultCol = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  overflow: auto;
  flex-shrink: 0;
  width: 300px;
  padding: 16px 20px;
  border-left: 1px solid var(--line);
  background: var(--card);
  color: var(--ink);
  box-shadow: var(--shadow-lg);
  z-index: 999;

  @media (min-width: 1200px) {
    width: 420px;
  }
  .content-box {
    border: 1px solid var(--line);
    padding: 10px 14px;
    border-radius: 12px;
    margin-bottom: 10px;
    background: var(--card-warm);
    transition: 0.2s all var(--ease);
    &:hover {
      border-color: var(--o1);
      box-shadow: var(--shadow);
    }
  }

  .tablist {
    list-style: none;
    margin: 0 0 20px;
    padding: 0;
    display: flex;
    gap: 15px;
    position: relative;
    padding-right: 35px;

    @media (min-width: 1400px) {
      gap: 30px;
    }
    .source-close {
      width: 28px;
      height: 28px;
      border: 1px solid var(--line);
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      position: absolute;
      right: 0;
      top: 0;
      background: var(--card);
      color: var(--danger);
    }
    li {
      margin: 0;

      button {
        display: block;
        font-size: 15px;
        line-height: 20px;
        text-transform: capitalize;
        padding: 0 0 5px;
        color: var(--quiet);
        border-bottom: 2px solid transparent;

        @media (min-width: 1400px) {
          font-size: 16px;
          line-height: 22px;
        }

        &.active {
          font-weight: 700;
          color: var(--ink);
          border-bottom: 2px solid var(--o1);
        }
      }
    }
  }

  .tab-content {
    position: relative;

    .imgs-wrap,
    .video-wrap {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 15px;
    }
  }

  .content-box {
    position: relative;
    font-size: 14px;
    line-height: 18px;
    cursor: pointer;

    .head {
      margin: 0 0 10px;
      display: flex;
      align-items: center;
      gap: 10px;

      .img-box {
        width: 22px;
        flex-shrink: 0;
      }

      .text {
        font-size: 14px;
        line-height: 18px;
        display: block;
        color: var(--quiet);
        max-width: 200px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .text-box {
      width: 100%;
    }
    .title {
      display: block;
      font-size: 16px;
      line-height: 20px;
      font-weight: 700;
      margin: 0 0 10px;
    }

    .detail-holder {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      width: 400px;
      padding: 15px;
      border-left: 1px solid #cdcdcd;
      border-radius: 10px 0 0 10px;
      background: var(--white);
      transform: translateX(102%);
      transition: all 0.3s ease-in-out;
      z-index: 72;

      .detail-active & {
        transform: translateX(0);
      }

      @media screen and (min-width: 1600px) {
        width: 500px;
      }

      .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        margin: 0 0 15px;

        .title {
          font-size: 18px;
          line-height: 22px;
          font-weight: 700;
          margin: 0;
        }

        .btn-close {
          width: 25px;
          height: 25px;
          border: 1px solid var(--text-color);
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
        }
      }

      .text-area {
        width: 100%;
        height: calc(100vh - 70px);
        overflow: auto;
        padding-right: 5px;
      }
    }
  }
  .block-heading {
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
    margin-bottom: 20px;
    color: var(--text-color-50);
  }

  .imgs-holder {
    max-width: 100%;
    overflow-x: auto;
    .img-wrap {
      width: 100%;
      height: 200px;
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        margin-bottom: 20px;
      }
    }
  }
`;

export const ReponseMenu = styled(Menu)`
  ul {
    width: 300px;
    padding: 10px;
    border-radius: 20px;
    border: 3px solid rgba(157, 157, 157, 0.4);
    box-shadow: 0 0 10px rgba(157, 157, 157, 0.6);
  }
`;
export const MenuBtn = styled(MenuButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 50px;
  padding: 10px 6px;
  font-size: 14px;
  line-height: 17px;
  font-weight: 500;
  text-transform: capitalize;
  border-radius: 12px;
  border: 1px solid rgba(157, 157, 157, 0.6);
  background: #f1f1f1;

  .icon-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 35px;
    height: 35px;
    border-radius: 12px;
    background: rgba(26, 42, 108, 0.1);
  }
`;
export const StyleItem = styled(MenuItem)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px;
  margin: 0 0 6px;
  border-radius: 10px;
  border: 1px solid transparent;

  &.active,
  &:hover {
    border-color: var(--text-color);
    background: rgba(254, 221, 88, 0.1);
  }

  &:last-child {
    margin: 0;
  }

  .wrap {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .icon-box {
    width: 35px;
  }

  .pro {
    display: block;
    min-width: 50px;
    padding: 5px;
    font-size: 14px;
    line-height: 17px;
    text-transform: capitalize;
    color: var(--text-color);
    text-align: center;
    border-radius: 10px;
    background: var(--primary);
  }
`;
